import React, { useState, useEffect } from 'react'
import { useApi } from '../../hooks/useApi'

const G2BulkCatalogPicker = ({ onSelect, onClose }) => {
  const [catalog, setCatalog] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [error, setError] = useState(null)
  const api = useApi()

  useEffect(() => {
    const fetchCatalog = async () => {
      try {
        const data = await api.getG2BulkCatalog()
        setCatalog(data.items || [])
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    fetchCatalog()
  }, [])

  const filtered = catalog.filter(item =>
    item.name?.toLowerCase().includes(search.toLowerCase()) ||
    item.id?.toString().includes(search)
  )

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="card w-full max-w-2xl max-h-[80vh] flex flex-col animate-fade-in">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-text-primary">Browse G2Bulk Catalog</h2>
          <button onClick={onClose} className="text-text-muted hover:text-text-primary text-xl">&times;</button>
        </div>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search products..."
          className="input mb-4"
          autoFocus
        />

        <div className="flex-1 overflow-y-auto">
          {loading && (
            <div className="flex items-center justify-center py-12">
              <div className="spinner w-8 h-8"></div>
            </div>
          )}

          {error && (
            <div className="text-center py-8">
              <p className="text-error">{error}</p>
            </div>
          )}

          {!loading && !error && filtered.length === 0 && (
            <div className="text-center py-8 text-text-muted">
              No products found
            </div>
          )}

          <div className="space-y-2">
            {filtered.map((item) => (
              <button
                key={item.id}
                onClick={() => onSelect(item)}
                className="w-full text-left p-3 rounded-lg bg-background hover:bg-accent/5 border border-border hover:border-accent/30 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-text-primary font-medium text-sm">{item.name}</div>
                    <div className="text-text-muted text-xs mt-0.5">
                      ID: {item.id} {item.denomination && `• ${item.denomination}`}
                    </div>
                  </div>
                  {item.price && (
                    <div className="text-accent font-medium text-sm">${item.price}</div>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="pt-4 border-t border-border mt-4">
          <button onClick={onClose} className="btn btn-secondary w-full">Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default G2BulkCatalogPicker
